import Moment from "moment/moment";
import NotificationsTypeIcon from "site-apps/notifications/NotificationsTypeIcon";

const MessagePreviewCard = ({item, isSelected, userLang}) => {
    const texts = item.notify.texts || {};
    const text = texts[userLang] || texts["es"] || texts[Object.keys(texts)[0]] || {};

    const messageHtml = text.description || "";
    const tempElement = document.createElement("div");
    tempElement.innerHTML = messageHtml;
    const textContent = tempElement.querySelector("p")?.innerHTML || "";

    return (
        <div
            style={{
                ...styles.card,
                backgroundColor: isSelected ? "#e9ecef" : "#fff",
                border: isSelected ? "2px solid #fff" : "1px solid #ddd",
            }}>
            <div style={styles.header}>
                <h3 style={styles.title}>{item.notify.sender}</h3>
                <div style={{display: "flex", alignItems: "baseline"}}>
                    <p style={styles.date}>{Moment(item.notify.created_at).format("DD/MM/YYYY HH:mm:ss")}</p>
                    <NotificationsTypeIcon type={item.notify.type} />
                </div>
            </div>
            <p style={styles.notifyTitle}>{text.title}</p>
            <div className="col-12" dangerouslySetInnerHTML={{__html: textContent}} />
        </div>
    );
};

const styles = {
    card: {
        borderRadius: "4px",
        padding: "15px",
        transition: "all 0.2s ease",
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    title: {
        margin: "0",
        fontSize: "18px",
        marginLeft: "5px",
    },
    date: {
        margin: "0",
        color: "#666",
        fontSize: "12px",
        paddingRight: "10px",
    },
    notifyTitle: {
        marginLeft: "5px",
        fontSize: "14px",
        borderBottom: "1px solid #ddd",
    },
    content: {
        margin: "0",
        fontSize: "11px",
        lineHeight: "1.5",
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
};

export default MessagePreviewCard;
